import styled from 'styled-components';

export const List = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
}));
